import { Box, Tooltip } from '@lego/klik-ui';
import { BanSolid, StatusSuccessBold } from '@lego/klik-ui/icons';

type Props = {
  isDisabled: boolean;
};

export const FileStatusIcon = (props: Props) => {
  return (
    <Box pl={1}>
      {props.isDisabled ? (
        <Tooltip label="This file is disabled and will not be deployed.">
          <BanSolid color="red" />
        </Tooltip>
      ) : (
        <Tooltip label="This file is enabled and available for deployment.">
          <StatusSuccessBold color="green" />
        </Tooltip>
      )}
    </Box>
  );
};
